<template>
  <v-list-item class="pr-1" style="min-height: 56px;" @click="itemClick">
    <v-list-item-content>
      <v-list-item-title>
        <slot>{{ title }}</slot>
      </v-list-item-title>
    </v-list-item-content>
    <v-list-item-icon v-if="to">
      <v-icon>{{ icon }}</v-icon>
    </v-list-item-icon>
  </v-list-item>  
</template>

<script>
export default {
  name: "MenuItem",

  props: {
    to: {
      type: [Object, String],
      default: null,
    },
    title: {
      type: String,
    },
    icon: {
      type: String,
      default: 'mdi-chevron-right'
    },
  },

  methods: {
    itemClick() {
      if (!this.to) {
        this.$emit('click')
      } else {
        this.$router.push(this.to)
      }
    }
  }
}
</script>